import PublicTrustCentrePage from "./PublicTrustCentrePage";

function App() {
  return <PublicTrustCentrePage />;
}

export default App;